<script setup>
import { ref, computed, watch, onMounted, onUpdated } from 'vue'
import { storeToRefs } from 'pinia'
import { langUrl, openPopup, closePopup, scrollToItemByGroup } from '@/helpers'
import IdleTimer from '@/components/IdleTimer.vue'
import { useLangStore } from '@/stores/app/lang'
import { useMenuStore } from '@/stores/gallery/menu'
import { useSlideshowStore } from '@/stores/gallery/slideshow'
import listScrollData from '@/assets/json/popup-list-scroll.json'

const langStore = useLangStore()
const menuStore = useMenuStore()
const slideshowStore = useSlideshowStore()
const popup_closeTimeout = config.idleTimer.popup_closeTimeout * 1000

// State -----------------------------------------
const { lang } = storeToRefs(useLangStore())
const isMounted = ref(false)

// Getters ---------------------------------------
const place = computed(() => menuStore.place)
const category = computed(() => menuStore.category)
const items = computed(() => {
  const arr1 = slideshowStore.items.filter((e) => e.place == place.value && e.category == category.value)
  return arr1.map((e) => {
    const { scrollGroupTH, scrollGroupEN } = listScrollData.find((x) => x.id == e.id)
    const scrollGroup = lang.value == 'en' ? scrollGroupEN : scrollGroupTH
    return { ...e, scrollGroup }
  })
})

const btnDescVisible = computed(() => {
  return category.value < 4 ? 'visible' : 'hidden'
})

// Methods ---------------------------------------
function imgItem(item) {
  const ext = item.actived ? 'gif' : 'png'
  return langUrl(`/images/popup/th/text_${item.place}_${item.category}_${item.order}.${ext}`)
}

function updateScrollbar() {
  const item = items.value.find((e) => e.actived)
  scrollToItemByGroup(item.scrollGroup, false)
}

// Events ----------------------------------------
onMounted(() => {
  isMounted.value = true
  console.log('[PopupList] onMounted()')
  setTimeout(() => {
    updateScrollbar()
  }, 100)
})

function onClickItem(item) {
  slideshowStore.setActivedItem(item.id)
}

function onIdleTrigger_popupClose() {
  console.info('%c[PopupList] onIdleTrigger_popupClose()', style.info)
  closePopup()
}

function onAfterLeaveChangeLang() {
  console.log('[PopupList] onAfterLeaveChangeLang()')
  updateScrollbar()
}

// Main Setup ------------------------------------

// -----------------------------------------------
</script>

<template>
  <transition name="fade-lang" @after-leave="onAfterLeaveChangeLang()">
    <div class="popup-list" :key="lang" :lang="lang">
      <img class="title" :src="langUrl(`/images/popup/th/title-list-${place}-${category}.png`)" />
      <div
        class="desc-wrapper scrollbar"
        scroll-wrapper="scroll-wrapper"
        :lang="lang"
        :place="place"
        :category="category"
      >
        <div class="desc">
          <template v-for="(item, i) in items">
            <img class="item" :scroll-group="item.scrollGroup" :src="imgItem(item)" @click="onClickItem(item, i)" />
          </template>
        </div>
      </div>
      <img class="btn-close" :src="langUrl(`/images/popup/th/btn-see-desc.png`)" @click="closePopup()" />
      <img
        :style="{ visibility: btnDescVisible }"
        class="btn-desc"
        :src="langUrl(`/images/main/th/btn-desc.png`)"
        @click="openPopup('PopupDesc')"
      />

      <Teleport to="#timer" v-if="isMounted">
        <idle-timer
          v-if="popup_closeTimeout"
          title="Popup.CloseTimeout"
          color="orange"
          :timeout="popup_closeTimeout"
          @idle-trigger="onIdleTrigger_popupClose"
        />
      </Teleport>
    </div>
  </transition>
</template>

<style scoped>
.popup-list {
  position: absolute;
  width: 460px;
  height: 700px;
  background: url(/images/popup-bg.png) no-repeat;
}

.title {
  position: absolute;
  top: 30px;
  left: 0;
  right: 0;
  margin: auto;
}

.desc-wrapper {
  position: absolute;
  top: 110px;
  left: 40px;
  width: 380px;
  height: 450px;
  margin: 0 auto;
  text-align: center;
  overflow-y: auto;
}

/* .desc-wrapper[lang='en'][place='1'] {
  height: 450px;
} */

.desc {
  padding-bottom: 0;
}

.item {
  cursor: pointer;
}

.btn-close {
  position: absolute;
  top: 580px;
  left: 0;
  right: 0;
  margin: 0 auto;
  cursor: pointer;
}

.btn-desc {
  position: absolute;
  top: 640px;
  left: 0;
  right: 0;
  margin: 0 auto;
  cursor: pointer;
}
</style>
